module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-right-panel-2-72993690efa064f14e7e835fb05d57d2.svg";